import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { typography, colors } from '@/styles';

export const H1 = styled.span`
    ${typography.sansSerif}

    font-weight: 800;
    font-size: 28px;
    line-height: 1.2;
`;

export const Body1 = styled.span`
    ${typography.sansSerif}

    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
`;

export const BodyText = styled.span`
    ${typography.sansSerif}
    white-space: nowrap;
    font-weight: 400;
    font-size: 14px;
    text-align: left;
`;
